import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import SlideShow, { SlideItem } from "../../components/Slideshow/";
import { useNavigate, useLocation } from "react-router-dom";
import ApiContent from "../../services/Content";
import ApiCommonContent from "../../services/GenericContent";
import "./styles.scss";
import {
  Content,
  CommonContent,
  ContentKey,
  ContentType,
} from "../../types/Types";
import GenericContent from "../../services/GenericContent";
import _ from "lodash";
import LoadingSkeleton from "../../components/Skeleton/HowToPlay";

const RankingPage = () => {
  const [content, setContent] = React.useState<Content[] | undefined>(
    undefined
  );

  const [commonContent, setCommonContent] = React.useState<
    CommonContent[] | undefined
  >(undefined);

  const [slides, setSlides] = React.useState<SlideItem[]>([]);

  const navigate = useNavigate();
  const location = useLocation();

  const handleGoBack = () => {
    const { homePage } = location.state || {};
    if (homePage) {
      navigate("/");
      return;
    }
    navigate(-1);
  };

  useEffect(() => {
    if (!content) {
      ApiContent.getContent().then((content) => {
        console.log(content);
        setContent(content);
        getSlides(content);
      });
      ApiCommonContent.getContent().then((content) => {
        console.log(content);
        setCommonContent(content);
      });
    }
  }, [slides]);

  const getSlides = (content: Content[]) => {
    const records: SlideItem[] = ApiContent.filterByContentType(
      content,
      ContentType.HOW_TO_PLAY_SLIDER
    ).map(({ title, moreInfo, moreInfoLabel, media, id, body, order }) => {
      return { title, moreInfo, moreInfoLabel, media, id, body, order };
    });
    setSlides(_.orderBy(records, ["order"], ["asc"]));
    console.log("slides:", slides);
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <Container className="containerAzulmedio" maxWidth="md">
        <AppBar position="static" className="topBarHowToPlay">
          <Toolbar className="toolBarBlue">
            <IconButton
              onClick={() => {
                handleGoBack();
              }}
              edge="start"
              color="inherit"
              aria-label="menu"
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {GenericContent.getKeyValue(
                commonContent,
                ContentKey.HOW_TO_PLAY
              )}
            </Typography>
          </Toolbar>
        </AppBar>

        {slides.length > 0 ? (
          <SlideShow
            startPlayingTitle={GenericContent.getKeyValue(
              commonContent,
              ContentKey.OK_LABEL
            )}
            data={slides}
          />
        ) : (
          <LoadingSkeleton/>
        )}
      </Container>
    </React.Fragment>
  );
};

export default RankingPage;
